import React from 'react';

import { ButtonEnums } from '../Button';
import LegacyViewportActionBar from '../LegacyViewportActionBar';
import Notification from '../Notification';

export interface StudyData {
	label: string;
	isTracked: boolean;
	isLocked: boolean;
	isRehydratable: boolean;
	studyDate: string;
	currentSeries: number;
	seriesDescription: string;
	modality: string;
	patientInformation: {
		patientName: string;
		patientSex: string;
		patientAge: string;
		MRN: string;
		thickness: string;
		spacing: string;
		scanner: string;
	};
}

export interface ViewportProps {
	viewportId: string;
	onArrowsClick: () => void;
	studyData: StudyData;
	children: React.ReactNode;
}

const Viewport: React.FC<ViewportProps> = ({ viewportId, onArrowsClick, studyData, children }) => {
	return (
		<div className="relative flex h-full flex-col">
			<div className="absolute left-0 top-0 w-full">
				<LegacyViewportActionBar onArrowsClick={onArrowsClick} studyData={studyData} />

				{/* TODO: NOTIFICATION API DEFINITION - OHIF-112 */}
				<Notification
					message="Track all measurement for this series?"
					type="info"
					actions={[
						{
							type: ButtonEnums.type.cancel,
							text: 'No',
							value: 0,
						},
						{
							type: ButtonEnums.type.secondary,
							text: 'No, do not ask again',
							value: -1,
						},
						{
							type: ButtonEnums.type.primary,
							text: 'Yes',
							value: 1,
						},
					]}
					onSubmit={(value) => {
						if (typeof window !== 'undefined') {
							window.alert(value);
						}
					}}
				/>
			</div>

			{/* STUDY IMAGE */}
			<div className="h-full w-full" id={viewportId}>
				{children}
			</div>
		</div>
	);
};

export default Viewport;
